
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termsofservice/TermsOfServicePage/TermsOfServicePage",
      function () {
        return require("private-next-pages/termsofservice/TermsOfServicePage/TermsOfServicePage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termsofservice/TermsOfServicePage/TermsOfServicePage"])
      });
    }
  